import React, { useContext, useEffect, useRef, useState } from "react";
import { baseUrl } from '../../config.js'
import { Imagenes, idServiciosRC, iconoServicio, idsRC, nombres } from "../../almacen.js";
import { BuscadorContext } from "../Buscador/BuscadorContext.js";
import Modal from "../Modal/Modal";
import './Filtros.css';

import PriceUp from '../../img/PriceUp.png';
import mejorCal from '../../img/mejorcal.png';
import PriceDown from '../../img/PriceDown.png';
import EspacioUp from '../../img/EspacioUp.png';
import EspacioDown from '../../img/EspacioDown.png';
import TimeUp from '../../img/TimeUp.png';
import TimeDown from '../../img/TimeDown.png';
import Todos from '../../img/todosPallet.png';
import Aprobacion from '../../img/aprobacion.png';
import Inmediato from '../../img/inmediato.png';

const Filtros = ({ setModalFiltro })=>{
    const {filtros, setFiltros, maximo, precios} = useContext(BuscadorContext);
    const [scrollEnd, setScrollEnd] = useState(false);
    const [scrollStart, setScrollStart] = useState(true);
    const [sel, setSel] = useState(filtros?.order || "Best");
    const [reserva, setReserva] = useState(filtros?.reserve || "All");
    const [selPeriodo, setSelPeriodo] = useState(filtros?.time || "3");
    const [min, setMin] = useState(filtros?.min || 0);
    const [max, setMax] = useState(filtros?.max || maximo["3"]*30);
    const [seleccionados, setSeleccionados] = useState({types:[...(filtros?.types ||[])], services:[...(filtros?.services || [])]});
    const [minResv, setMinResv] = useState({
        time: '',
        period: '1',
    })
    const [credit, setCredit] = useState('')
    const contFiltros = useRef();
    const multiplica = {
        "1" : 1,
        "2" : 7,
        "3" : 30,
        "4" : 365,
    }

    return(
        <Modal className='divFiltros' titulo={'Filtros'} setModal={setModalFiltro}>
            <div className="contFiltros filtro-modal" ref={contFiltros} onScroll={(e)=>{
                const scroll = Math.floor(e.target.scrollHeight - e.target.offsetHeight);
                if(Math.floor(e.target.scrollTop) <= 0){
                    setScrollEnd(false);
                    setScrollStart(true);
                }
                else if(Math.ceil(e.target.scrollTop) >= scroll){
                    setScrollEnd(true);
                    setScrollStart(false);
                }
                else{
                    if(!scrollStart){
                        setScrollEnd(true);
                        setScrollStart(false);
                    }
                    else{
                        setScrollEnd(false);
                        setScrollStart(true);                        
                    }
                }
            }}>
            <section className="filtro-sec immediate">
                <h3 className="filtro-sec__title">Mostrar</h3>
                <p className="filtro-sec__sub">Elige cómo quieres rentar</p>
                <div className="botonesFiltro botonesFiltro--mostrar">
                    <button onClick={()=>{
                        setReserva("All");
                    }} className={reserva == "All" ? "sel" : ""}>
                        <img src={Todos}/>
                        <span>Todos</span>
                    </button>
                    <button onClick={()=>{
                        setReserva("Immediate");
                    }} className={reserva == "Immediate" ? "sel" : ""}>
                        <img src={Inmediato}/>
                        <span>Reserva Inmediata</span>
                    </button>
                    <button onClick={()=>{
                        setReserva("Approve");
                    }} className={reserva == "Approve" ? "sel" : ""}>
                        <img src={Aprobacion}/>
                        <span>Proceso de Aprobación</span>
                    </button>
                </div>
            </section>
                <section className="filtro-sec orderBy">
                    <h3 className="filtro-sec__title">Ordenar por</h3>
                    <p className="filtro-sec__sub">Define el orden de los resultados</p>
                    <div className="botonesFiltro botonesFiltro--ordenar">
                        <button onClick={()=>{
                            setSel("Best");
                        }} className={sel == "Best" ? "sel" : ""}>
                            <img src={mejorCal}/>
                            <span>Mejores Calificados</span>
                        </button>
                        <button onClick={()=>{
                            setSel("Recent");
                        }} className={sel == "Recent" ? "sel" : ""}>
                            <img src={TimeDown}/>
                            <span>Recientes</span>
                        </button>
                        <button onClick={()=>{
                            setSel("Oldest");
                        }} className={sel == "Oldest" ? "sel" : ""}>
                            <img src={TimeUp}/>
                            <span>Antiguos</span>
                        </button>
                        <button onClick={()=>{
                            setSel("MoreAvailability");
                        }} className={sel == "MoreAvailability" ? "sel" : ""}>
                            <img src={EspacioDown}/>
                            <span>Más Espacios</span>
                        </button>
                        <button onClick={()=>{
                            setSel("LessAvailability");
                        }} className={sel == "LessAvailability" ? "sel" : ""}>
                            <img src={EspacioUp}/>
                            <span>Menos Espacios</span>
                        </button>
                        <button onClick={()=>{
                            setSel("PriceDown");
                        }} className={sel == "PriceDown" ? "sel" : ""}>
                            <img src={PriceDown}/>
                            <span>Mayor Costo</span>
                        </button>
                        <button onClick={()=>{
                            setSel("PriceUp");
                        }} className={sel == "PriceUp" ? "sel" : ""}>
                            <img src={PriceUp}/>
                            <span>Menor Costo</span>
                        </button>
                    </div>
                </section>
                <section className="filtro-sec filtrarPrecio" onDragOver={(e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    e.dataTransfer.dropEffect = 'move';
                }}>
                    <h3 className="filtro-sec__title">Rango de precios</h3>
                    <p className="filtro-sec__sub">Ajusta el presupuesto por periodo</p>
                    <div className="contPeriodos">
                        <div className="selPeriodo">
                            <button className={selPeriodo == "1" ? "sel" : ""} onClick={()=>{
                                setSelPeriodo("1")
                            }}>Flexible</button>
                            <button className={selPeriodo == "2" ? "sel" : ""} onClick={()=>{
                                setSelPeriodo("2")
                            }}>Semana</button>
                            <button className={selPeriodo == "3" ? "sel" : ""} onClick={()=>{
                                setSelPeriodo("3")
                            }}>Mes</button>
                            <button className={selPeriodo == "4" ? "sel" : ""} onClick={()=>{
                                setSelPeriodo("4")
                            }}>Año</button>
                        </div>
                    </div>
                    <Grafica precios={precios[selPeriodo]} maximo={maximo[selPeriodo]} min={min} max={max} multiplica={multiplica[selPeriodo]}/>
                    <Slider min={min} setMin={setMin} max={max} setMax={setMax} maximo={maximo[selPeriodo]} multiplica={multiplica[selPeriodo]}/>
                </section>

                <section className="filtro-sec minimosFiltro">
                    <div className="filtro-mini">
                        <h3 className="filtro-sec__title">Renta</h3>
                        <p className="filtro-sec__sub">Duración mínima</p>
                        <form>
                            <label>
                                <input type="number" value={minResv.time} onChange={(e)=>{
                                    setMinResv({...minResv, time: e.target.value})
                                }}/>
                                <span>Renta mínima</span>
                            </label>
                            <label>
                                <select selected={minResv.period} onChange={(e)=>{
                                    setMinResv({...minResv, period : e.target.value})
                                }}>
                                    <option value="1">Día(s)</option>
                                    <option value="2">Semana(s)</option>
                                    <option value="3">Mes(es)</option>
                                    <option value="4">Año(s)</option>
                                </select>
                            </label>
                        </form>
                    </div>
                    <div className="filtro-mini">
                        <h3 className="filtro-sec__title">Crédito</h3>
                        <p className="filtro-sec__sub">Días de crédito</p>
                        <form>
                            <label>
                                <input type="number" value={credit} onChange={(e)=>{
                                    setCredit(e.target.value);
                                }}/>
                                <span>Crédito mínimo (días)</span>
                            </label>
                        </form>
                    </div>
                </section>
                <section className="filtro-sec filtrarTipos">
                    <h3 className="filtro-sec__title">Tipo de almacén</h3>
                    <p className="filtro-sec__sub">Selecciona una o varias opciones</p>
                    <div className="tipos">
                        {Object.keys(idsRC).map(id=>{
                            return(
                                <label key={id}>
                                    <input type="checkbox" defaultChecked={seleccionados.types.includes(id)} onChange={(e)=>{
                                        if(e.target.checked){
                                            seleccionados.types.push(id);
                                        }
                                        else{
                                            seleccionados.types.splice(seleccionados.types.indexOf(id), 1);
                                        }
                                    }}/>
                                    <div>
                                        <img src={Imagenes[idsRC[id]]}/>
                                        <div>{nombres[id]}</div>
                                    </div>
                                </label>
                            )
                        })
                        }
                    </div>
                </section>
                <section className="filtro-sec filtrarServicios">
                    <h3 className="filtro-sec__title">Servicios básicos</h3>
                    <p className="filtro-sec__sub">Lo esencial del espacio</p>
                    <div className="tipos">
                        {[9,10,11,13].map(id=>{
                            return(
                                <label key={id}>
                                    <input type="checkbox" defaultChecked={seleccionados.services.includes(id)} onChange={(e)=>{
                                        if(e.target.checked){
                                            seleccionados.services.push(id);
                                        }
                                        else{
                                            seleccionados.services.splice(seleccionados.services.indexOf(id), 1);
                                        }
                                    }}/>
                                    <div>
                                        <img src={iconoServicio(id)} alt=""/>
                                        <div>{idServiciosRC[id]}</div>
                                    </div>
                                </label>
                            )
                        })
                        }
                    </div>
                </section>
                <section className="filtro-sec filtrarServicios">
                    <h3 className="filtro-sec__title">Servicios operativos</h3>
                    <p className="filtro-sec__sub">Operación y valor agregado</p>
                    <div className="tipos">
                        {[1,2,3,7,12].map(id=>{
                            return(
                                <label key={id}>
                                    <input type="checkbox" defaultChecked={seleccionados.services.includes(id)} onChange={(e)=>{
                                        if(e.target.checked){
                                            seleccionados.services.push(id);
                                        }
                                        else{
                                            seleccionados.services.splice(seleccionados.services.indexOf(id), 1);
                                        }
                                    }}/>
                                    <div>
                                        <img src={iconoServicio(id)} alt=""/>
                                        <div>{idServiciosRC[id]}</div>
                                    </div>
                                </label>
                            )
                        })
                        }
                    </div>
                </section>
            </div>
            <div className="opcionesFiltros">
                {!scrollEnd &&
                    <button
                        type="button"
                        className="filtro-scroll filtro-scroll--down"
                        aria-label="Ver más filtros"
                        onClick={()=>{
                            contFiltros.current.scrollTo({top: contFiltros.current.scrollTop + 250, behavior: "smooth"});
                        }}
                    >
                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Más filtros</span>
                    </button>
                }
                {!scrollStart &&
                    <button
                        type="button"
                        className="filtro-scroll filtro-scroll--up"
                        aria-label="Volver arriba"
                        onClick={()=>{
                            contFiltros.current.scrollTo({top: contFiltros.current.scrollTop - 250, behavior: "smooth"});
                        }}
                    >
                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M6 15l6-6 6 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>Arriba</span>
                    </button>
                }
                <button className="btn quitar" onClick={()=>{
                    setFiltros({...filtros, types:[], services:[], min: undefined, max: undefined, time: undefined, order: undefined})
                    setReserva("All");
                    setModalFiltro(false);
                }}>Quitar Filtros</button>
                <button className="btn guardar" onClick={()=>{
                    const nombre = window.prompt("¿Cómo deseas nombrar esta búsqueda?");
                    if(nombre){
                        const filtrosParaGuardar = {
                            types: seleccionados.types, 
                            services: seleccionados.services, 
                            min, 
                            max, 
                            time: selPeriodo, 
                            order: sel, 
                            reserve: reserva,
                            credit: credit,
                            minResv: minResv,
                        };
                        let guardadas = JSON.parse(localStorage.getItem('busquedasGuardadas') || '[]');
                        guardadas.push({nombre, filtros: filtrosParaGuardar});
                        localStorage.setItem('busquedasGuardadas', JSON.stringify(guardadas));
                        window.alert("Búsqueda guardada exitosamente. La verás en la barra superior al recargar.");
                    }
                }}>Guardar Búsqueda</button>
                <button className="btn" onClick={()=>{
                    if(min === 0 && max === maximo[selPeriodo]*multiplica[selPeriodo])
                        setFiltros({...filtros, 
                            types: seleccionados.types, 
                            services: seleccionados.services, 
                            order: sel, 
                            reserve: reserva,
                            credit: credit,
                            minResv: minResv,
                        })
                        else
                        setFiltros({...filtros, 
                            types: seleccionados.types, 
                            services: seleccionados.services, 
                            min, 
                            max, 
                            time: selPeriodo, 
                            order: sel, 
                            reserve: reserva,
                            credit: credit,
                            minResv: minResv,
                        })
                    setModalFiltro(false);
                }}>Mostrar Resultados</button>
            </div>
        </Modal>
    )
}

const Slider = ({min, setMin, max, setMax, maximo, multiplica, selPeriodo})=>{
    const[inicio, setInicio] = useState(min*100/(maximo*multiplica));
    const[final, setFinal] = useState(max*100/(maximo*multiplica));
    const slider = useRef();
    
    useEffect(()=>{
        setMin(Math.round(inicio*maximo*multiplica)/100);
    },[inicio, multiplica])
    
    useEffect(()=>{
        setMax(Math.round(final*maximo*multiplica)/100);
    },[final, multiplica])

    const handleDrag = (e)=>{
        e.preventDefault();
        const start = slider.current.offsetLeft;
        const size = slider.current.offsetWidth;
        const porcentaje = (e.clientX-start)*100/size;
        if(porcentaje < final && porcentaje > 0){
            const valor = Math.floor((e.clientX-start)*100/size);
            const margen = (((maximo*multiplica*5)/100))*100/(maximo*multiplica);
            if(valor < max-margen){
                setInicio(valor);
            }
            else{
                setInicio(max-margen);
            }
        }
    }
    
    const handleDragF = (e)=>{
        e.preventDefault();
        const start = slider.current.offsetLeft;
        const size = slider.current.offsetWidth;
        const porcentaje = (e.clientX-start)*100/size;
        if(porcentaje > inicio && porcentaje < 100){
            const valor = Math.ceil((e.clientX-start)*100/size);
            const margen = (((maximo*multiplica*5)/100))*100/(maximo*multiplica);
            if(valor > min+margen){
                setFinal(valor);
            }
            else{
                setFinal(min+margen);
            }
        }
    }
    const handleDragEnd = (e)=>{
        e.preventDefault();
        const start = slider.current.offsetLeft;
        const size = slider.current.offsetWidth;
        const porcentaje = (e.clientX-start)*100/size;
        if(porcentaje < final && porcentaje > 0)
            setInicio(Math.floor((e.clientX-start)*100/size));
    }
    const handleDragEndF = (e)=>{
        e.preventDefault();
        const start = slider.current.offsetLeft;
        const size = slider.current.offsetWidth;
        const porcentaje = (e.clientX-start)*100/size;
        if(porcentaje > inicio && porcentaje < 100)
            setFinal(Math.ceil((e.clientX-start)*100/size));
    }

    // touch
    
    const handleTouchDrag = (e)=>{
        const start = slider.current.offsetLeft;
        const size = slider.current.offsetWidth;
        const porcentaje = (e.touches[0].clientX-start)*100/size;
        if(porcentaje < final && porcentaje > 0)
            setInicio(Math.floor((e.touches[0].clientX-start)*100/size));
    }
    
    const handleTouchDragF = (e)=>{
        const start = slider.current.offsetLeft;
        const size = slider.current.offsetWidth;
        const porcentaje = (e.touches[0].clientX-start)*100/size;
        if(porcentaje > inicio && porcentaje < 100)
            setFinal(Math.ceil((e.touches[0].clientX-start)*100/size));
    }

    return(
        <>
            <div className="slider" ref={slider}>
                <div className="progreso inicio" style={{width:inicio+"%"}}></div>
                <div className="bola inicio"
                    draggable={true}
                    style={{left:"calc("+inicio+"% - 1em)"}}
                    onDragStart={(e)=>{
                        const span = document.createElement("span");
                        e.dataTransfer.setDragImage(span,null,null)
                    }}
                    onDrag={handleDrag}
                    onDragEnd={handleDragEnd}
                    onTouchMove={handleTouchDrag}
                    ></div>
                <div className="bola final"
                    draggable={true}
                    style={{right:"calc("+(100-final)+"% - 1em)"}}
                    onDragStart={(e)=>{
                        const span = document.createElement("span");
                        e.dataTransfer.setDragImage(span,null,null)
                    }}
                    onDrag={handleDragF}
                    onDragEnd={handleDragEndF}
                    onTouchMove={handleTouchDragF}
                    ></div>
                <div className="progreso final" style={{width:(100-final)+"%"}}></div>
            </div>
            <div>
                <form className="minMax">
                    <label>
                        <div className="simbolo">$</div>
                        <input type="number" value={min} min={0} max={max} onChange={(e)=>{
                            if(e.target.value < max){
                                setInicio(e.target.value*100/(maximo*multiplica))
                            }
                            else{
                                setInicio((max-((maximo*multiplica*5)/100))*100/(maximo*multiplica))
                            }
                        }
                        }/>
                        <span>Mínimo</span>
                    </label>
                    <span></span>
                    <label>
                        <div className="simbolo">$</div>
                        <input type="number" value={max} min={min} max={maximo*multiplica} onChange={(e)=>{
                            if(e.target.value > min)
                                setFinal(e.target.value*100/(maximo*multiplica))
                            else{
                                setFinal((min+((maximo*multiplica*5)/100))*100/maximo*multiplica);
                            }
                        }
                        }/>
                        <span>Máximo</span>
                    </label>
                </form>
            </div>
        </>
    )
}

const Grafica = ({precios, maximo, min, max, multiplica})=>{
    const ancho = maximo*multiplica/50;
    const [masAlto, setMasAlto] = useState(0);
    const [alto, setAlto] = useState([]);
    useEffect(()=>{
        const aux = Array(50).fill(0);
        precios?.forEach(precio => {
            const indice = Math.floor(precio*multiplica/ancho);
            if(!aux[indice])
                aux[indice] = 0;
            aux[indice] += 1;
        });
        setAlto(aux);
        setMasAlto(Math.max(...aux));
    },[precios])
    return(
        <div className="graficaPrecios">
            {alto.map((x,i)=>{
                return(
                    <div key={i} style={{height:(x*100/masAlto)+"%"}} className={i*ancho < min || (i)*ancho > max ? "disabled" : ""}></div>
                );
            })
            }
        </div>
    )
}

export default Filtros;